<app-template-date [disabled]="disabled" [value]="value" [control]="control" [label]="label" />
